import React from 'react';
import { useForm } from 'react-hook-form';
import useMoreFilters from '@/components/search/hooks/useMoreFilters';
import MoreFiltersMobile from './moreFiltersMobile/MoreFiltersMobile';
import useSearchParams from '@/components/search/hooks/useSearchParams';
import useDevice from '@/hooks/useDevice';
import FilterChips from '../reusabe/filterChips/FilterChips';
import Drawer from '@/components/UI/drawer/Drawer';
import Modal from '@/components/UI/modal/Modal';
import useDrawer from '@/hooks/useDrawer';
const MoreFilters = () => {
  const {
    setQuery,
    queries,
    routerAsPath
  } = useSearchParams();
  const {
    drawerOpen,
    drawerClose,
    isDrawerOpen
  } = useDrawer();
  const {
    isMobile
  } = useDevice();
  const {
    reset
  } = useForm();
  const {
    selectedMoreFilters,
    moreFilters
  } = useMoreFilters();
  const checked = Object.values(selectedMoreFilters(queries)).length;
  const handleClickOpen = () => drawerOpen('MORE_FILTER');
  const resetFilter = e => {
    e.stopPropagation();
    const clearedFilter = Object.keys(selectedMoreFilters(queries))?.reduce((acc, curr) => ({
      ...acc,
      [curr]: undefined
    }), {});
    setQuery(clearedFilter);
  };
  React.useEffect(() => {
    const defaultValues = {};
    moreFilters.flatMap(item => item.list).forEach(item => {
      defaultValues[item.query] = queries?.[item.query] ? 1 : null;
    });
    reset({
      ...defaultValues
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [routerAsPath]);
  return <>
      <FilterChips type="secondary" checked={!!checked} label={checked ? `${checked} فیلتر` : 'فیلتر ها'} startIcon="filter" handleClick={handleClickOpen} handleClean={resetFilter} name="all_filter" endIcon data-sentry-element="FilterChips" data-sentry-source-file="MoreFilters.tsx" />
      {!isMobile ? <Modal open={isDrawerOpen('MORE_FILTER')} onClose={drawerClose}>
          <MoreFiltersMobile onClose={drawerClose} queryParams={queries} setQuery={setQuery} handleClean={resetFilter} />
        </Modal> : <Drawer open={isDrawerOpen('MORE_FILTER')} onClose={drawerClose} fullHeight>
          <MoreFiltersMobile onClose={drawerClose} queryParams={queries} setQuery={setQuery} handleClean={resetFilter} />
        </Drawer>}
    </>;
};
export default React.memo(MoreFilters);